import React, { Component } from 'react';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ToolsWidget from '../../components/ToolsWidget/ToolsWidget';
import Skeleton from "../../components/Skeleton/Skeleton";
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import ContentTiles from "../../components/ContentTiles/ContentTiles";
import store from "../../store";
import {Helmet} from "react-helmet";

class GuidelinesAndTools extends Component {

  render() {
    return (
      <div className="wrapper">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "Ship" ? row.sections.map((section) => {
                          return section.title === "Guidelines & Tools" ? <meta name="description" content={section.content['seo-description']}/> : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs
          pageTitle="Guidelines & Tools"
        />
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL"/>}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
          templateUrl="./content/ship/page-components/text-block/guidelines-tools-heading.html"
        />
        <ContentTiles
          jsonDataUrl="./content/ship/page-components/article/guidelines-tools.json"
          pathForItem="/ship/guidelines-and-tools/guideline-and-tool"
        />
        <div className="mb36">
          <ToolsWidget/>
        </div>
      </div>
    );
  }
}

export default GuidelinesAndTools;



// WEBPACK FOOTER //
// ./src/pages/ship/GuidelinesAndTools.js